import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "../ui/Button";
import { MetricCard } from "../ui/MetricCard";
import { ScoreIndicator } from "../ui/ScoreIndicator";
// import ProductModal from "../../Layout/Domain/ProductModal";
import ModelSummary from "./ModelSummary";
// import { AssetDetailModal } from "./AssetDetailModal";
import { FaAngleRight, FaArrowLeft } from "react-icons/fa";
import { Database } from 'lucide-react';
import './SubdomainDetail.scss';
import Tooltip from "@mui/material/Tooltip";
import Layer1 from "../../../assests/Layer_1.png"
import group1 from "../../../assests/Vector.png";
import circle from "../../../assests/Group3702.png";
export const AssetsSummary = ({ subdomain, onBack, onL5Click }) => {
  //   const [selectedProducts, setSelectedProducts] = useState(null);
  //   const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  //   const [isAssetModalOpen, setIsAssetModalOpen] = useState(false);

  console.log("Product Detail", subdomain);
  const rowsPerPage = 30;

  const filteredRows =
    subdomain?.product_assets_detail?.filter((sub) =>
      sub.data_asset_name.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];
  console.log("filteredRows", filteredRows);

  const totalRows = filteredRows.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredRows.slice(indexOfFirstRow, indexOfLastRow);
  console.log("Subdomain Detail currentRows", currentRows);

  const [selectedAsset, setSelectedAsset] = useState(null);

  //   const closeAssetModal = () => {
  //     setIsAssetModalOpen(false);
  //     setSelectedAsset(null);
  //   };

  //   const closeModal = () => {
  //     setIsModalOpen(false);
  //     setSelectedProducts(null);
  //   };

  //   const handleAssetClick = (data) => {
  //     setSelectedAsset(data);
  //   };

  console.log("Subdomain Detail selectedAsset", selectedAsset);

  function getPartAfterPipe(str) {
    if (!str) return "";
    const parts = str.split("|");
    return parts.length > 1 ? parts[1] : str;
  }

  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="flex absolute justify-end gap-2.5 right-6 top-8 mt-[35px] z-50">
        <button
          style={{ marginTop: "35px" }}

          onClick={onBack}
          className="text-[#bb1ccc] hover:text-white transition-colors duration-200 border border-[#bb1ccc] p-2 rounded-lg flex items-center gap-2 hover:bg-[#bb1ccc] hover:shadow-lg px-4"
        >
          <FaArrowLeft />   Go Back
        </button>
      </div>

      {/* Subdomain Summary */}
      <div className="rounded-lg p-4 text-white relative">
        <h1 className="text-3xl font-bold text-black mb-4">
          {subdomain.product_name}
        </h1>
        <p className="text-lg text-black mb-4 leading-relaxed">
          {subdomain.product_description}
        </p>
        {/* <div className="mb-4 absolute top-5 right-10">
          <ModelSummary
            title={subdomain.name}
            text={subdomain.description_expanded || "N/A"}
          />
        </div> */}

        {/* Summary Metrics */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

          <MetricCard
            title="Critical Data Elements"
            value={subdomain?.product_cde_count ? subdomain?.product_cde_count : "0"}
            variant="success"
          />
          <MetricCard
            title="Quality Score"
            value={subdomain?.product_score ? subdomain?.product_score : "0%"}
            variant="warning"
          />
          <MetricCard
            title="Total Assets"
            value={subdomain?.product_assets ? subdomain?.product_assets : "0"}
            variant="primary"
          />
        </div>
      </div>

      {/* L3 Sub-domains */}
      {subdomain &&
        subdomain.product_assets_detail &&
        subdomain.product_assets_detail.length > 0 && (
          <div className="space-y-6 p-2">
            <div className="flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-900">
                Assets Details
              </h2>
              <div className="flex items-center space-x-2">
                <input
                  type="text"
                  placeholder="Search Assets..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1); // Reset page when search updates
                  }}
                  className="border border-gray-300 rounded px-3 py-1 text-sm w-[300px] h-[40px] focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>

            {/* CARD VIEW - COMMENTED OUT */}
            {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {currentRows.map((l3Subdomain) => {
                return (
                  <div
                    key={l3Subdomain.data_asset_name}
                    onClick={() => onL5Click(l3Subdomain?.data_asset_name)}
                    className="bg-white rounded-lg border border-gray-200 cursor-pointer hover:shadow-lg transition-all duration-200 min-w-0 flex flex-col"
                  >
                    <div className="flex items-start justify-between bg-gray-100 border-b border-gray-200 p-4">
                      <div className="flex-1 min-w-0">
                        <div className="flex justify-between align-center mb-3 min-w-0">
                          <div style={{ alignItems: "center" }} className="text-xl font-semibold text-gray-900 case capitalize flex align-center gap-4 min-w-0 flex-1">
                            <span style={{ alignContent: "center", alignItems: "center" }} className="bg-[#3da046] w-[35px] h-[35px] rounded-xl grid justify-center flex-shrink-0">
                              <Database width="18px" color="white" />
                            </span>
                            <Tooltip
                              title={getPartAfterPipe(l3Subdomain.data_asset_name)}
                              arrow
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    bgcolor: "black",
                                    color: "white",
                                    fontSize: "0.9rem",
                                    borderRadius: "6px",
                                  },
                                },
                                arrow: { sx: { color: "black" } },
                              }}
                            >
                              <span className="line-clamp-1 break-words cursor-help flex-1">
                                {getPartAfterPipe(l3Subdomain.data_asset_name)}
                              </span>
                            </Tooltip>
                          </div>
                          <button
                            onClick={() => onL5Click(l3Subdomain?.data_asset_name)}
                            className="text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 ml-2"
                          >
                            <FaAngleRight size={20} />
                          </button>
                        </div>

                        <p className="text-gray-600 line-clamp-1  overflow">
                          {l3Subdomain.asset_description}
                        </p>
                      </div>
                    </div>

                    <div className="mt-1 p-4 ">
                      <div className="flex items-center justify-between  mb-1">
                        <span className='text-black'>Quality Score</span>
                        <span className='text-black'>{l3Subdomain.asset_score}</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div 
                          className={`h-2 rounded-full transition-all duration-300 ${
                            parseFloat(l3Subdomain.asset_score) > 95 ? 'bg-green-700' : 
                            parseFloat(l3Subdomain.asset_score) < 90 ? 'bg-red-500' : 
                            parseFloat(l3Subdomain.asset_score) > 90 ?  'bg-yellow-700':
                            'bg-gray-700'
                          }`}
                          style={{ width: `${parseFloat(l3Subdomain.asset_score)}%` }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div> */}

            {/* TABLE VIEW */}
            <div className="bg-white rounded-lg shadow overflow-hidden">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-sm font-medium text-black uppercase tracking-wider">
                        Asset Name
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-black uppercase tracking-wider">
                        Description
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-black uppercase tracking-wider">
                        Quality Score
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-black uppercase tracking-wider">
                        Status
                      </th>
                      <th className="px-6 py-3 text-center text-sm font-medium text-black uppercase tracking-wider">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {currentRows.map((l3Subdomain, index) => (
                      <tr 
                        key={l3Subdomain.data_asset_name}
                        className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-blue-50 transition-colors`}
                      >
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <span className="bg-[#3da046] w-[35px] h-[35px] rounded-xl flex items-center justify-center flex-shrink-0 mr-3">
                              <Database width="18px" color="white" />
                            </span>
                            <Tooltip
                              title={getPartAfterPipe(l3Subdomain.data_asset_name)}
                              arrow
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    bgcolor: "black",
                                    color: "white",
                                    fontSize: "0.9rem",
                                    borderRadius: "6px",
                                  },
                                },
                                arrow: { sx: { color: "black" } },
                              }}
                            >
                              <span className="text-sm font-medium text-gray-900 cursor-help">
                                {getPartAfterPipe(l3Subdomain.data_asset_name)}
                              </span>
                            </Tooltip>
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          <span className="text-sm text-gray-600">
                            {l3Subdomain.asset_description || 'N/A'}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div className="w-16 bg-gray-200 rounded-full h-2 mr-2">
                              <div 
                                className={`h-2 rounded-full transition-all duration-300 ${
                                  parseFloat(l3Subdomain.asset_score) > 95 ? 'bg-green-600' : 
                                  parseFloat(l3Subdomain.asset_score) < 90 ? 'bg-red-500' : 
                                  parseFloat(l3Subdomain.asset_score) >= 90 ? 'bg-yellow-500' :
                                  'bg-gray-500'
                                }`}
                                style={{ width: `${parseFloat(l3Subdomain.asset_score)}%` }}
                              />
                            </div>
                            <span className="text-sm font-medium text-gray-900">
                              {l3Subdomain.asset_score}
                            </span>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className="px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-[#bb1ccc]">
                            {l3Subdomain.asset_status || 'Active'}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-center">
                          <button
                            onClick={() => onL5Click(l3Subdomain?.data_asset_name)}
                            className="text-[#bb1ccc] hover:text-white border border-[#bb1ccc] hover:bg-[#bb1ccc] px-3 py-1 rounded transition-colors duration-200 text-sm font-medium"
                          >
                            View Details
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}



      <div className="pagination flex items-center justify-between mt-4 px-4">
        <span className="text-sm text-gray-600">
          Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, totalRows)}{" "}
          of {totalRows} entries
        </span>
        <div className="pagination-controls flex space-x-1">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
            className="px-2 py-1 border rounded disabled:opacity-50 hover:bg-gray-50 transition-colors duration-200"
          >
            Previous
          </button>
          {[...Array(totalPages)].map((_, idx) => (
            <button
              key={idx}
              className={`px-3 py-1 border rounded transition-colors duration-200 ${currentPage === idx + 1
                ? "bg-blue-500 text-white"
                : "hover:bg-gray-50"
                }`}
              onClick={() => setCurrentPage(idx + 1)}
            >
              {idx + 1}
            </button>
          ))}
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
            className="px-2 py-1 border rounded disabled:opacity-50 hover:bg-gray-50 transition-colors duration-200"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
